<template>
  <Layout kind="narrow">
    <div class="section">
      <div class="content">
	<h1>{{$t('Directory')}}</h1>
	<hr>
	<div>
	  <div class="has-background-white is-hidden" style="position: sticky; top: 0; left: 0">
	    <ul class="is-unstyled">
	      <li v-for="groupName, index in sortedGroupNames" :key="index" style="display: inline;">
		<a :href="$router.resolve({ name: 'Directory', hash: `#${groupName}`}).href">
		  {{ groupName.toUpperCase() }}
		</a>
	      </li>
	    </ul>
	  </div>
	  <ul class="is-unstyled">
	    <li v-for="(groupName, index) in sortedGroupNames" :key="index">
	      <ul class="is-unstyled">
		<h3>{{ groupName.toUpperCase() }} <a :name="groupName"></a></h3>
		<hr>
		<li v-for="(document, index) in groupedDocuments[groupName]" :key="index">
      <RouterLink :to="linksById[document.id]">
		    {{ document.title }}
		  </RouterLink>
		</li>
	      </ul>
	      <hr>
	    </li>
	  </ul>
	</div>
      </div>
    </div>
  </Layout>
</template>

<style>
 .is-unstyled {
   list-style: none !important;
   margin-left: 0 !important;
 }
</style>

<script>
 export default {
   data() {
     return {
       documents: [],
       isReady: false
     }
   },
   watch: {
     ['$route']: {
       handler(to, from) {
	 const route = this.$router.currentRoute;
	 const id = route.hash;
	 this.$nextTick(() => {
           if (id && document.querySelector(id)) {
             document.querySelector(id).scrollIntoView();
           }
	 })
       },
       immediate: true
     }
   },
   computed: {
     groupedDocuments() {
       const grouped = {}
       for (const document of this.documents) {
	 const firstLetter = document.title[0].toLowerCase()

	 if (!(firstLetter in grouped)) {
	   grouped[firstLetter] = []
	 }

	 grouped[firstLetter].push(document)
       }

       return grouped
     },
     sortedGroupNames() {
       return Object.keys(this.groupedDocuments).sort((s, t) => s.localeCompare(t))
     },
     linksById() {
       return this.documents.reduce((obj, val) => ({
	 ...obj,
	 [val.id]: { name: 'Document', params: { documentId: val.id}}
       }), {})
     }
   },
   async mounted() {
     const { items } = await this.api.fetchDocuments({ limit: 1024 })

     this.documents = items

     this.isReady = true;
   }
 }
</script>
